import React from "react";
import { motion } from "framer-motion";
import { toast } from "sonner";
import { AndroidLogo, AppleLogo, CheckCircle, DeviceMobile, ArrowLeft } from "@phosphor-icons/react";
import { Logo } from "@/components/Logo";
import { useApp } from "@/context/AppContext";

export default function AppLanding() {
  const { t } = useApp();
  const soon = () => toast.message(t("appComingSoon"));

  return (
    <div className="min-h-[100dvh] w-full" style={{ background: "var(--app-bg)" }} data-testid="app-landing">
      <div className="mx-auto max-w-md px-6 py-12 flex flex-col items-center text-center">
        <Logo className="h-14 mb-6" />
        <span className="text-xs font-heading font-semibold uppercase tracking-wider px-3 py-1 rounded-full text-white mb-4" style={{ background: "var(--app-primary)" }}>
          {t("appComingSoon")}
        </span>
        <motion.h1 initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }}
          className="text-3xl font-heading font-semibold text-gray-900 flex items-center gap-2">
          <DeviceMobile size={30} weight="duotone" style={{ color: "var(--app-strong)" }} />SafeBuddy NFC App
        </motion.h1>
        <p className="mt-4 text-base font-body text-gray-700 leading-relaxed">{t("appLandingIntro")}</p>

        <div className="sb-card w-full p-5 mt-8 text-left space-y-3">
          {[t("appLandingFeature1"), t("appLandingFeature2"), t("appLandingFeature3")].map((f, i) => (
            <div key={i} className="flex items-start gap-3">
              <CheckCircle size={22} weight="fill" className="shrink-0 mt-0.5" style={{ color: "#22C55E" }} />
              <span className="font-body text-gray-800">{f}</span>
            </div>
          ))}
        </div>

        <div className="w-full mt-8 space-y-3">
          <button data-testid="landing-playstore" onClick={soon}
            className="sb-btn w-full py-3.5 bg-white font-medium flex items-center justify-center gap-2">
            <AndroidLogo size={22} weight="fill" style={{ color: "#3DDC84" }} />{t("playStoreBtn")}
          </button>
          <button data-testid="landing-appstore" onClick={soon}
            className="sb-btn w-full py-3.5 bg-white font-medium flex items-center justify-center gap-2">
            <AppleLogo size={22} weight="fill" className="text-gray-900" />{t("appStoreBtn")}
          </button>
        </div>

        <a data-testid="landing-back" href="/" className="mt-8 flex items-center gap-1 font-heading font-medium underline" style={{ color: "var(--app-strong)" }}>
          <ArrowLeft size={18} weight="bold" />{t("backToApp")}
        </a>
      </div>
    </div>
  );
}
